module.exports = __webpack_public_path__ + "static/media/man_04.51d4b580.png";